/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult2,
  NotFoundErrorResult2,
  ResultOfAnnuityDetailsViewModel,
  ValidationErrorResult2,
} from '../models';
import {
    ErrorResult2FromJSON,
    ErrorResult2ToJSON,
    NotFoundErrorResult2FromJSON,
    NotFoundErrorResult2ToJSON,
    ResultOfAnnuityDetailsViewModelFromJSON,
    ResultOfAnnuityDetailsViewModelToJSON,
    ValidationErrorResult2FromJSON,
    ValidationErrorResult2ToJSON,
} from '../models';

export interface IssuedProductGetAnnuityDetailsRequest {
    clientId?: string | null;
}

/**
 * 
 */
export class IssuedProductApi extends runtime.BaseAPI {

    /**
     * Get annuity product details for a client
     */
    async issuedProductGetAnnuityDetailsRaw(requestParameters: IssuedProductGetAnnuityDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfAnnuityDetailsViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v1/issued-product/annuity-details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfAnnuityDetailsViewModelFromJSON(jsonValue));
    }

    /**
     * Get annuity product details for a client
     */
    async issuedProductGetAnnuityDetails(requestParameters: IssuedProductGetAnnuityDetailsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfAnnuityDetailsViewModel> {
        const response = await this.issuedProductGetAnnuityDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
